module.exports = __webpack_public_path__ + "static/media/Coin_Icon@3x.2d0daa44.png";